/* eslint-disable @typescript-eslint/no-unused-vars */
import { fireEvent } from '@testing-library/react';

export const areWeTestingWithJest = (): boolean =>
    process.env.JEST_WORKER_ID !== undefined && process.env.NODE_ENV === 'test';
export const getFieldMetaMock = (name: string, value: string): any => ({
    value,
    initialTouched: true,
    touched: false,
});

export const getFieldHelpersMock = (name: string): any => ({
    /** Set the field's value */
    setValue: (value: any, shouldValidate?: boolean) => {},
    /** Set the field's touched value */
    setTouched: (value: boolean, shouldValidate?: boolean) => {},
    /** Set the field's error value */
    setError: (value: string | undefined) => {},
});

export const setMuiCheckBox = (
    input: HTMLInputElement,
    newValue: boolean
): any => {
    // find the root span of our checkbox
    const root = input.closest('.MuiButtonBase-root');
    if (root) {
        const isChecked = root.classList.contains('Mui-checked');
        if (isChecked !== newValue) {
            fireEvent.click(input);
        }
    }
};
